import PickEmApp from './PickEmApp';

const Index = () => {
  return <PickEmApp />;
};

export default Index;
